import {externalBaseApi, extractData} from "../../api/axiosConfig";



export const getAllSubscribers = () =>
    externalBaseApi
        .get("/subscriber")
        .then(extractData);

export const addSubscriber = data =>
    externalBaseApi
        .post("/subscriber", data)
        .then(extractData);

export const editSubscriber = (subscriberId, data) =>
    externalBaseApi
        .put(`/subscriber/${subscriberId}`, data)
        .then(extractData);

export const deleteSubscriber = subscriberId =>
    externalBaseApi
        .delete(`/subscriber/${subscriberId}`)
        .then(extractData);

export const getSubscriberObligationData = cdpvId =>
    externalBaseApi
        .get("/subscriber/obligationData", {
            params: {
                my_cdpv_id: cdpvId
            }
        })
        .then(extractData);

export const uploadSubscriber = subscriber =>
    externalBaseApi
        .post("/subscriber/upload", subscriber)
        .then(extractData);

export const getSources = () =>
    externalBaseApi
        .get("/subscriber/source")
        .then(extractData);

export const subscriberSearch = request =>
    externalBaseApi
        .post("/subscriber/subscriberSearch", request)
        .then(extractData);

//
// import axios from "axios";
//
// const BASE_URL = import.meta.env.VITE_BACKEND_URL;
//
//
//
// export const getAllSubscribers = () =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/subscriber`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export   const addSubscriber = abcd =>
//     axios.post(`${BASE_URL}/ExternalData/api/contramatic/subscriber`, abcd, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const editSubscriber = (selectorSubscriberId, data) =>
//     axios.put(`${BASE_URL}/ExternalData/api/contramatic/subscriber/${selectorSubscriberId}`, data, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
//
// //https://www.javatpoint.com/react-axios-delete-request-example except that it shows the wrong kinds of quotes - not backquotes
// export const deleteSubscriber = subscriberId =>
//     axios.delete(`${BASE_URL}/ExternalData/api/contramatic/subscriber/${subscriberId}`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const getSubscriberObligationData = (my_cdpv_id) =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/subscriber/obligationData`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_cdpv_id: my_cdpv_id}
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export   const uploadSubscriber = (subscriber) =>
//     axios.post(`${BASE_URL}/ExternalData/api/contramatic/subscriber/upload`,subscriber, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getSources = () =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/subscriber/source`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const subscriberSearch = (request) =>
//
//     axios.post(
//         `${BASE_URL}/ExternalData/api/contramatic/subscriber/subscriberSearch`,
//         request,
//         // CONFIG
//         {
//             headers: {
//                 Authorization:
//                     'Bearer ' + localStorage.getItem('token'),
//                 'Content-Type': 'application/json'
//             // }
//         }
//     )
//
//         .catch(function (error) {
//
//             if (error.response) {
//
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//
//             } else if (error.request) {
//
//                 console.log(error.request);
//
//             } else {
//
//                 console.log('Error', error.message);
//
//             }
//
//             console.log(error.config);
//
//         });